export enum UserRoles{
    Collaborator = "Collaborator",
    NetworkMember = "NetworkMember",
    ContentEditor = "ContentEditor",
    Client = "Client"
}